import React, { createContext, useState, useEffect, ReactNode } from "react";
import { jwtDecode } from "jwt-decode";

interface User {
  userId: string;
  username: string;
  name?: string;
  vendor_id?: number;
}

interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  login: () => void;
  logout: () => void;
  hasRole: (role: string, club?: string) => boolean;
  benefitsTag: any[];
  setBenefitsTag: any;
}

// Create context with default values
export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  user: null,
  login: () => {},
  logout: () => {},
  hasRole: () => false,
  benefitsTag: [],
  setBenefitsTag: () => {},
});

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<User | any>(null);
  const [benefitsTag, setBenefitsTag] = useState<any>(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    let userData: any = localStorage.getItem("user");
    userData = JSON.parse(userData);
    if (token && userData) {
      try {
        const decoded = jwtDecode<any>(token);
        if (userData.type === "member") {
          logout();
        } else {
          setIsAuthenticated(true);
          setUser(userData);
        }
      } catch (error) {
        console.error("Failed to decode token", error);
        logout();
      }
    }
  }, []);

  const login = () => {
    const token = localStorage.getItem("token");
    let userData: any = localStorage.getItem("user");
    userData = JSON.parse(userData);

    if (token && userData) {
      try {
        const decoded = jwtDecode<any>(token);
        if (userData.type === "member") {
          logout();
        } else {
          setIsAuthenticated(true);
          setUser(userData);
        }
      } catch (error) {
        console.error("Failed to decode token", error);
        logout();
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setUser(null);
  };

  /**This hasRole function created to check the type and club based on which after login navigation handle */
  const hasRole = (role?: string, club?: string) => {
    if (role === user?.type && club) {
      return club === user?.club;
    } else {
      return user?.type?.toLowerCase() === role?.toLowerCase();
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        login,
        logout,
        hasRole,
        benefitsTag,
        setBenefitsTag,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
